import { render, staticRenderFns } from "./MinUserInfo.vue?vue&type=template&id=b09afcfe"
import script from "./MinUserInfo.vue?vue&type=script&lang=js"
export * from "./MinUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports